import React from "react";
import type { FC } from "react";
import {
  Body,
  Flex,
  FlexRow,
  Heading,
  RawMoney,
  Money as MoneyComponent,
} from "@edreamsodigeo/prisma-design-system";

import type { FareCardHeaderProps } from "~/components/common/FareCard/contract";
import { getDefaultFareCardPriceStyle } from "~/components/common/FareCard/styles/styles";

export const FareCardHeader: FC<FareCardHeaderProps> = ({
  title,
  price,
  discountedPrice,
  type,
  priceDescription,
  subtitle,
}) => {
  const isPrimary = type === "primary";
  const priceStyle = getDefaultFareCardPriceStyle(isPrimary);

  return (
    <FlexRow justifyContent={"space-between"}>
      <Flex
        flexDirection={"column"}
        gap={"1"}
        alignItems={"flex-start"}
        maxWidth={"70%"}
      >
        <Heading type={"4"} color={"neutral.90"} weight={"medium"}>
          {title}
        </Heading>
        {subtitle && (
          <Body type={"xSmall"} color={"neutral.60"}>
            {subtitle}
          </Body>
        )}
      </Flex>
      <Flex flexDirection={"column"} alignItems={"flex-end"}>
        <Flex
          gap={"2x_small"}
          alignItems={"baseline"}
          justifyContent={"flex-end"}
        >
          {discountedPrice && (
            <Body type={"small"} weight={"normal"} color={"neutral.70"}>
              <RawMoney
                currency={price.currency}
                strikeThrough={"default"}
                rounded
              >
                {price.amount}
              </RawMoney>
            </Body>
          )}
          <Heading type={"3"} weight={"medium"} sx={priceStyle.sx}>
            <MoneyComponent
              currency={(discountedPrice ?? price).currency}
              rounded
            >
              {(discountedPrice ?? price).amount}
            </MoneyComponent>
          </Heading>
        </Flex>
        {priceDescription && (
          <Body
            type={"xSmall"}
            color={"neutral.70"}
            sx={{ fontStyle: "italic" }}
          >
            {priceDescription}
          </Body>
        )}
      </Flex>
    </FlexRow>
  );
};
